import { checkLogin } from '@apis/signIn';
import SignInForm from '@components/signIn/SignInForm';
import { Link, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';
import storeInfo from '../../recoil/storeInfo/atom';
import Cookies from 'js-cookie';

const SignIn = () => {
  const userType = Cookies.get('userType');
  const navigation = useNavigate();
  const setCurrentStoreInfo = useSetRecoilState(storeInfo);

  const logoutHandler = async () => {
    setCurrentStoreInfo({
      currentStore: '',
      currentAuthority: '',
      currentStoreId: undefined,
      storeLists: [],
    });
  };

  useEffect(() => {
    const checkLoginHandler = async () => {
      try {
        const response = await checkLogin();
        if (response) {
          navigation('/admin/dashboard');
        } else {
          logoutHandler();
        }
      } catch {
        // 로그인 전이면 401 등 에러 발생 - 정상이므로 무시
      }
    };
    checkLoginHandler();
  }, []);

  return (
    <div id="sign_in_container">
      <h1 className="main_title">매출내역 조회 서비스</h1>
      <h2 className="sub_text">
        {userType === 'kis' ? 'KIS' : 'SMARTLAB'}에 로그인 후, 언제 어디서나 <br />
        손쉽게 매출 내역을 확인하세요
      </h2>
      <SignInForm />
      <div className="btn_wrapper">
        <Link to={'/signup'} className="sign_up_btn">
          회원가입
        </Link>
        {/* 나중에 해야함 */}
        {/* <Link to={'/signup'} className="find_pw_btn">
          비밀번호 찾기
        </Link> */}
      </div>

      <span className="customer_center_text">고객센터 02-2632-6599</span>
    </div>
  );
};

export default SignIn;
